import {
    ServicesPageContainer,
    ServicePageOverlay,
    ServicePageBg,
    ServicePageContent,
    ServicePageTitle,
    ServicePageSecondContent,
    ServicePageSubText,
    ServicesPricingSection,
    ServicePageSubTextBottom
} from "../ServicesElements";
import {
    PricingGrid,
    PricingCard,
    PricingImage,
    PricingBody,
    PricingTitle,
    PricingList,
    PricingFooter,
    PricingFootText,
    PricingButton
} from "../PricingElements";
import {
    DesktopOnly,
    MobileOnly,
    MobileContainer,
    MobileTitle,
    MobileVideo
} from "../../CommonElements";
import { useNavigate } from "react-router-dom";
import basicImage from "../../../images/pricing/EventBasic.png";
import standardImage from "../../../images/pricing/EventStandard.png";
import premiumImage from "../../../images/pricing/EventPremium.png";

const Event = () => {
    const navigate = useNavigate();
        const plans = [
        {
            img: basicImage,
            titleDecoration: "⭐",
            title: "Basic Package",
            price: "from £599",
            noListStyle: true,
            features: [
                "✔ 4h Event Coverage",
                "✔ 1 Highlight Video (1-2min)",
                "✔ Short Teaser Clip",
                "✔ Drone Footage",
                "✔ Premium Editing",
                "✔ Licensed Commercial Music",
                "✔ Online delivery within 14 days"
            ],
            footText: "👉 A simple but powerful way to capture your event and share it online.",
            cta: "APPLY NOW",
            link: "/summary?type=event_basic",
        },
        {
            img: standardImage,
            titleDecoration: "⭐⭐",
            title: "Standard Package",
            price: "£1199",
            noListStyle: true,
            features: [
                "✔ 6-8 hours Event Coverage",
                "✔ 1 Highlight Film (3-4min)",
                "✔ 3 Social Media Clips",
                "✔ Drone Footage",
                "✔ Premium Editing",
                "✔ Guest/Speaker Interview Shots",
                "✔ Licensed Commercial Music",
                "✔ Online delivery within 14 days",
            ],
            footText: "👉 The perfect balance of professional coverage and ready-to-use marketing content.",
            cta: "APPLY NOW",
            link: "/summary?type=event_standard",
        },
        {
            img: premiumImage,
            titleDecoration: "⭐⭐⭐",
            title: "Premium Package",
            price: "£1999",
            noListStyle: true,
            features: [
                "✔ Full Day Event Coverage",
                "✔ Full Event Film (4-5min)",
                "✔ 2 Camera Angles",
                "✔ 5 Social Media Clips",
                "✔ Teaser Video - 24 delivery!",
                "✔ Drone Footage",
                "✔ Premium Editing",
                "✔ Guest/Speaker Interview Shots",
                "✔ Licensed Commercial Music",
                "✔ Branded Landing Page",
            ],
            footText: "👉 Comprehensive coverage and a full set of marketing assets.\nEverything you need to showcase your event across every platform.",
            cta: "APPLY NOW",
            link: "/summary?type=event_premium",
        },
        ];

    return (
        <>
            <DesktopOnly>
                <ServicesPageContainer>
                    <ServicePageBg>
                        <video autoPlay loop muted playsInline className="App-logo">
                        <source src="/videos/Event_Video_Background.mp4" type="video/mp4" />
                        </video>
                        <ServicePageOverlay />
                    </ServicePageBg>

                    <ServicePageContent>
                        <ServicePageTitle>
                        Event Films that capture the spirit, energy 
                        <br />
                        <br />
                        <br />
                        and atmosphere, creating lasting impressions
                        <br />
                        </ServicePageTitle>
                    </ServicePageContent>
                </ServicesPageContainer>
            </DesktopOnly>

            <MobileOnly>
                <MobileContainer>
                    <MobileTitle mobileFontSize="15px">
                        Event Films that capture the spirit, energy
                        <br />
                        and atmosphere, creating lasting impressions
                    </MobileTitle>
                    <MobileVideo
                    autoPlay
                    muted
                    playsInline
                    loop
                    src="/videos/Event_Video_Background.mp4"
                    />
                </MobileContainer>
            </MobileOnly>
        <ServicePageSecondContent>
            <ServicePageSubText>
                From corporate gatherings and live concerts to private celebrations, we capture every moment with precision and creativity.
                <br />
                <br />
                <br />
                Our event videos don't just document — they tell the story, amplify the emotions, and let your audience relive the experience long after the lights go down.
                <br />
                <br />
                <br />
                Choose the Plan That Fits You Best
            </ServicePageSubText>
        </ServicePageSecondContent>
        <ServicesPricingSection>
            <PricingGrid>
                {plans.map((p) => (
                    <PricingCard key={p.title}>
                    {p.img && <PricingImage src={p.img} alt={p.title}  mobileHeight="220px"/>}
                    <PricingBody>
                        <PricingTitle><span style={{fontSize: '18px'}}>{p.titleDecoration}</span> {p.title} <span style={{fontSize: '18px'}}>{p.price}</span></PricingTitle>
                        <PricingList style={{ listStyle: p.noListStyle ? "none" : "disc", paddingLeft: p.noListStyle ? "0" : "18px" }}>
                        {p.features.map((f) => (
                            <li key={f}>{f}</li>
                        ))}
                        </PricingList>
                    </PricingBody>
                    <PricingFooter>
                        <PricingFootText>{p.footText}</PricingFootText>
                        <PricingButton type="button" aria-label={p.cta} onClick={() => navigate(p.link)}>
                        {p.cta}
                        </PricingButton>
                    </PricingFooter>
                    </PricingCard>
                ))}
            </PricingGrid>
        </ServicesPricingSection>
        <ServicePageSecondContent>
            <ServicePageSubText>
                Didn't find the right package? 
                <br />
                <br />
                <PricingButton type="button" aria-label={"👉 Request a Custom Quote"} onClick={() => navigate("/contact")}>
                    👉 Request a Custom Quote
                </PricingButton>
            </ServicePageSubText>
        </ServicePageSecondContent>
        <ServicePageSecondContent>
            <ServicePageSubTextBottom>
                <b>Show</b> the energy of your event
                <br />
                <br />
                <b>Turn</b> moments into unforgettable stories
                <br />
                <br />
                <b>Inspire</b> your audience, celebrate connections, and create memories
                <br />
                <br />
            </ServicePageSubTextBottom>
        </ServicePageSecondContent>
        </>
    )
};

export default Event;